import { render, staticRenderFns } from "./QuestionarioDinamico.vue?vue&type=template&id=10610644&scoped=true"
import script from "./QuestionarioDinamico.vue?vue&type=script&lang=js"
export * from "./QuestionarioDinamico.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioDinamico.vue?vue&type=style&index=0&id=10610644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10610644",
  null
  
)

export default component.exports